import type { ErrorEvent } from '@sentry/react';

// Our code always runs from bundled .js files. A stack whose every frame points at the
// page URL itself is script the browser injected (e.g. Chrome iOS page translation).
export function isInjectedScriptError(event: ErrorEvent): boolean {
  const frames = event.exception?.values?.flatMap((value) => value.stacktrace?.frames ?? []) ?? [];
  return frames.length > 0 && frames.every((frame) => !/\.m?js(\?|#|$)/.test(frame.filename ?? ''));
}

// Replay masks all text by default; these are app chrome with no patient data, shown so
// a replay is followable. Values typed into inputs stay masked (maskAllInputs).
export const REPLAY_UNMASK_SELECTORS = [
  '.sentry-unmask',
  '[data-sentry-unmask]',
  '.ant-menu',
  '.ant-tabs-nav',
  '.ant-table-thead',
  '.ant-form-item-label',
  '.ant-pagination',
  '.ant-segmented',
  '.ant-btn:not(.ant-btn-link)',
];
